import type { JSX } from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

export interface DeleteAccountConfirmDialogProps {
  visible: boolean
  displayName: string
  pending: boolean
  onCancel: () => void
  onConfirm: () => void
}

/** Confirms the irreversible hard-delete of an already-revoked connected account. */
export default function DeleteAccountConfirmDialog(props: DeleteAccountConfirmDialogProps): JSX.Element {
  return (
    <Dialog
      visible={props.visible}
      onHide={props.onCancel}
      header={`Delete ${props.displayName}`}
      style={{ width: '32rem' }}
      modal
    >
      <div className="space-y-3 text-sm">
        <p>
          {'Permanently delete '}<strong>{props.displayName}</strong>?
        </p>
        <p className="text-gray-700">
          This removes the account and its stored credentials entirely. This cannot be undone — to
          reconnect, you will need to add the account again from scratch.
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <Button label="Cancel" onClick={props.onCancel} disabled={props.pending} severity="secondary" />
          <Button label="Delete" onClick={props.onConfirm} disabled={props.pending} loading={props.pending} severity="danger" />
        </div>
      </div>
    </Dialog>
  )
}
